export const ACHIEVEMENTS_CONFIG = [
    {
        id: 'first_message',
        title: 'Первый шаг',
        description: 'Отправь своё первое сообщение',
        icon: '💬',
        condition: (stats) => stats.messages >= 1,
    },
    {
        id: 'curious',
        title: 'Любопытный',
        description: 'Отправь 10 сообщений',
        icon: '🔍',
        condition: (stats) => stats.messages >= 10,
    },
    {
        id: 'active_learner',
        title: 'Активный ученик',
        description: 'Отправь 50 сообщений',
        icon: '📚',
        condition: (stats) => stats.messages >= 50,
    },
    {
        id: 'communicator',
        title: 'Коммуникатор',
        description: 'Отправь 100 сообщений',
        icon: '🗣️',
        condition: (stats) => stats.messages >= 100,
    },
    {
        id: 'first_lesson',
        title: 'Начинающий',
        description: 'Изучи свой первый урок',
        icon: '🎓',
        condition: (stats) => stats.lessons >= 1,
    },
    {
        id: 'lesson_master',
        title: 'Ученик мастера',
        description: 'Изучи 5 уроков',
        icon: '📖',
        condition: (stats) => stats.lessons >= 5,
    },
    {
        id: 'first_test',
        title: 'Испытатель',
        description: 'Пройди свой первый тест',
        icon: '✅',
        condition: (stats) => stats.tests >= 1,
    },
    {
        id: 'level_5',
        title: 'Опытный',
        description: 'Достигни 5 уровня',
        icon: '⭐',
        condition: (stats, level) => level >= 5,
    },
];
